import { defaultGapBetweenSelectedSeatsRuleOptions, defaultMustFillSofaSeatsPartialSelectionRuleOptions, defaultSingleSeatGapFromAnAisleRuleOptions, defaultSingleSeatGapFromUnavailableSeatRuleOptions } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { seatPickerGapBetweenSelectedSeatsRuleConfigValidator } from './seat-selection-rules/gap-between-selected-seats-rule';
import { seatPickerSeatSelectionRuleConfigValidator } from './seat-selection-rules/seat-selection-rule';
import { seatPickerSingleSeatGapFromAnAisleRuleConfigValidator } from './seat-selection-rules/single-gap-from-aisle-rule';
import { seatPickerSingleSeatGapFromUnavailableSeatRuleConfigValidator } from './seat-selection-rules/single-gap-from-unavailable-seat-rule';
import { seatPickerSinglePartialSofaRuleConfigValidator } from './seat-selection-rules/single-partial-sofa-rule';
export const defaultSeatPickerSelectionRulesConfig = {
    cannotLeaveGapsBetweenSelectedSeats: {
        enabled: true,
        options: defaultGapBetweenSelectedSeatsRuleOptions
    },
    cannotLeaveSingleSeatGapFromAisle: {
        enabled: true,
        options: defaultSingleSeatGapFromAnAisleRuleOptions
    },
    cannotLeaveSingleSeatGapFromUnavailableSeat: {
        enabled: true,
        options: defaultSingleSeatGapFromUnavailableSeatRuleOptions
    },
    mustFillSofaSeats: {
        enabled: true,
        options: defaultMustFillSofaSeatsPartialSelectionRuleOptions
    },
    mustSelectAssociatedWheelchairSeat: {
        enabled: true
    },
    mustRespectSeatSelectionLimits: {
        enabled: true
    }
};
export const seatPickerSelectionRulesConfigValidatorSchema = {
    cannotLeaveGapsBetweenSelectedSeats: seatPickerGapBetweenSelectedSeatsRuleConfigValidator,
    cannotLeaveSingleSeatGapFromAisle: seatPickerSingleSeatGapFromAnAisleRuleConfigValidator,
    cannotLeaveSingleSeatGapFromUnavailableSeat: seatPickerSingleSeatGapFromUnavailableSeatRuleConfigValidator,
    mustFillSofaSeats: seatPickerSinglePartialSofaRuleConfigValidator,
    mustSelectAssociatedWheelchairSeat: seatPickerSeatSelectionRuleConfigValidator,
    mustRespectSeatSelectionLimits: seatPickerSeatSelectionRuleConfigValidator
};
export const seatPickerSelectionRulesConfigValidator = Validator.object(seatPickerSelectionRulesConfigValidatorSchema);
